import React from 'react';
import { Link } from 'react-router-dom';

import WhiteSymbolLogo from 'assets/images/logo/symbol_white.png';
import SNSLoginModal from 'contents/modal/SNSLoginModal';
import AlarmPopUpContent from 'contents/popup_button/AlarmPopUpContent';
import UserMenuPopupContent from 'contents/popup_button/UserMenuPopupContent';
import { transparentize } from 'polished';
import { useRecoilValue } from 'recoil';
import { userSNSState } from 'recoils/user/userState';
import styled, { css } from 'styled-components';

import Button from 'components/button/Button';
import Logo from 'components/logo/Logo';

import useAuthNavigate from 'hooks/common/useAuthNavigate';
import useGetLocal from 'hooks/common/useGetLocal';
import useViewMode from 'hooks/common/useViewMode';
import useHeader from 'hooks/menu/useHeader';
import { useHeaderMobile } from 'hooks/menu/useHeaderMobile';

import { TokenManager } from 'utils/security/securityUtil';
import { clickToGTM } from 'utils/seo/seoGTMUtil';

import MenuBar from './MenuBar';

/**
 * @desc 페이지 상단에 위치하는 헤더 컴포넌트
 * @returns {JSX.Element}
 */
const Header = () => {
  const userSnsInfo = useRecoilValue(userSNSState);
  const { onLoginBtnClick } = useHeader();
  const { isToggleMenu } = useHeaderMobile();
  const { authNavigate } = useAuthNavigate();
  const { isMobile } = useViewMode();
  useGetLocal();

  return (
    <>
      {/* 헤더 영역 */}
      <HeaderWrapper $isToggleMenu={isToggleMenu} className="header">
        <HeaderInner className="header_inner">
          <HeaderContainer className="header_container">
            {/* 로고 */}
            <Logo linkTo="/" />
            {/* 메뉴바 */}
            <MenuBar />
          </HeaderContainer>
          {/* 유틸리티 영역 */}
          <Util className="util">
            <UtilUserInfo>
              {!localStorage.getItem(TokenManager.token.access) ? (
                // 로그인 전 UI - 로그인 버튼
                <LoginButton
                  // variant="primary-dark"
                  // variant="dark-outline"
                  size="big"
                  shape="round20"
                  position="center"
                  onClick={onLoginBtnClick}
                  gtm={{
                    id: 'header-login-btn',
                    target: '로그인',
                    url: '/login',
                  }}
                >
                  로그인
                </LoginButton>
              ) : (
                // 로그인 후 UI - 알림, 계정, 콘솔 버튼
                <>
                  {/* 알림 팝업 버튼 */}
                  <AlarmPopUpContent />
                  {/* 유저 정보 팝업 버튼 */}
                  <UserMenuPopupContent />
                </>
              )}
            </UtilUserInfo>
            {/* 콘솔 버튼 */}
            <ConsoleButton
              onClick={() =>
                authNavigate(
                  isMobile ? '/user-info?view=mobile' : '/dash-board'
                )
              }
              variant="primary"
              size="big"
              shape="round20"
              position="center"
              gtm={{
                id: 'header-console-btn',
                target: 'CONSOLE',
                url: '/dash-board',
              }}
              buttonStyle={{ fontSize: '15px' }}
            >
              콘솔
            </ConsoleButton>
          </Util>
        </HeaderInner>
      </HeaderWrapper>
      {/* 회원가입 모달 */}
      {userSnsInfo.isopen && <SNSLoginModal />}
    </>
  );
};

export default Header;

// 스타일드 컴포넌트 정의
export const HeaderWrapper = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 60px;
  height: 66px;
  z-index: 99;
  transition: all 0.25s ease-out;
  box-shadow: ${({ theme }) => theme.color.shadowLight};

  ${({ $isToggleMenu }) =>
    $isToggleMenu
      ? css`
          background: ${({ theme }) => theme.color.white};
        `
      : css`
          background: ${({ theme }) => theme.color.gray30};
        `};
`;

export const HeaderInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  margin: 0 auto;
  width: 100%;
  // max-width: 1280px;
  max-width: 1440px;
  padding: 0 24px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Util = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  gap: 12px;
`;

const UtilUserInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

const LoginButton = styled(Button)`
  font-size: 15px;
  width: 90px;
  color: ${({ theme }) => theme.color.white};

  &:hover {
    // width: 100px;
    background: ${({ theme }) => theme.color.gray820};
  }
`;

const ConsoleButton = styled(Button)`
  width: 90px;
  &:hover {
    background: ${({ theme }) => transparentize(0.1, theme.color.primary)};
  }
`;
